import React from "react";
import { Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
const ReviewContainer = ({ img, title, refID, props, business }) => {
  return (
    <Col md={6} {...props} className="mb-3">
      <Card>
        <Card.Body>
          <Card.Img variant="top" style={{ height: 256 }} src={img} />
          <Card.Title>{title}</Card.Title>

          <Card.Text>Category: {business}</Card.Text>
          <div className="d-flex justify-content-end">
            <Link className="nav-link" to={`/reviews/${title}/${refID}`}>
              <Button variant="danger" size="lg" className="addbtn">
                View
              </Button>
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};
export default ReviewContainer;
